@if (isWinterSeason && meteoInfosReport.length > 0) {
  <ion-row class="sis-webreport-meteo-category-title">
    <ion-col [ngStyle]="{ 'font-size': config?.assetTitleFontSize, color: config?.assetTitleColor }">
      {{
      showWeatherTitle
      ? ('webreport.assetCategoryWeatherAndSnowConditions' | translate)
      : ('webreport.assetCategorySnowConditions' | translate)
      }}
    </ion-col>
  </ion-row>
  @for (row of meteoInfosReport; track trackByIndex($index, row)) {
    <ion-row class="sis-webreport-meteo-row">
      @for (weatherStation of row; track trackByGuid($index, weatherStation)) {
        <ion-col [size]="columnSize">
          <div class="sis-webreport-meteo-div">
            <ion-grid class="sis-webreport-meteo-item-grid">
              <ion-row class="sis-webreport-meteo-station-title">
                <ion-col style="align-content: center">
                  <span style="font-size: 20px">{{ weatherStation.location }}</span>
                  <span style="margin-left: 15px">{{
                    weatherStation.altitude.slice(0, -1) + ' ' + ('webreport.term.metersAboveSeaLevel' | translate)
                  }}</span>
                </ion-col>
                @if (showWeather) {
                  <ion-col size="2">
                    <ion-img
                      class="sis-webreport-meteo-image"
                [src]="
                  'assets/icons-meteo/desktop/' +
                  (weatherStation.weather ? weatherStation.weather : 'placeholder-meteo') +
                  '.svg'
                "
                    ></ion-img>
                  </ion-col>
                }
              </ion-row>
              <!-- Meteo Icons: https://www.svgrepo.com/collection/framework7-line-icons/ how to document?-->
              @if (showTemperature) {
                <ion-row class="sis-webreport-meteo-station-data">
                  <ion-col>
                    {{ 'webreport.term.temperature' | translate }}
                  </ion-col>
                  <ion-col>
                    {{ weatherStation.temperature + ' °C' }}
                  </ion-col>
                </ion-row>
              }
              @if (showWindSpeed && weatherStation.windSpeed) {
                <ion-row class="sis-webreport-meteo-station-data">
                  <ion-col>
                    {{ 'webreport.term.windSpeed' | translate }}
                  </ion-col>
                  <ion-col>
                    {{ weatherStation.windSpeed + ' km/h' }}
                  </ion-col>
                </ion-row>
              }
              @if (showSnowCondition && weatherStation.snowConditionId !== 0) {
                <ion-row
                  class="sis-webreport-meteo-station-data"
                  >
                  <ion-col>
                    {{ 'webreport.term.snowCondition' | translate }}
                  </ion-col>
                  <ion-col>
                    {{ getSnowConditionTranslationString(weatherStation.snowConditionId) | translate }}
                  </ion-col>
                </ion-row>
              }
              @if (showSlopeCondition && weatherStation.slopeConditionId !== 0) {
                <ion-row
                  class="sis-webreport-meteo-station-data"
                  >
                  <ion-col>
                    {{ 'webreport.term.slopeCondition' | translate }}
                  </ion-col>
                  <ion-col>
                    {{ getSlopeConditionTranslationString(weatherStation.slopeConditionId) | translate }}
                  </ion-col>
                </ion-row>
              }
              @if (showFreshSnow) {
                <ion-row class="sis-webreport-meteo-station-data">
                  <ion-col>
                    {{ 'webreport.term.freshSnow' | translate }}
                  </ion-col>
                  <ion-col>
                    {{ weatherStation.freshSnow + ' cm' }}
                  </ion-col>
                </ion-row>
              }
              @if (showSnowDepth) {
                <ion-row class="sis-webreport-meteo-station-data">
                  <ion-col>
                    {{ 'webreport.term.snowDepth' | translate }}
                  </ion-col>
                  <ion-col>
                    {{ weatherStation.snowDepth + ' cm' }}
                  </ion-col>
                </ion-row>
              }
              @if (showLatestSnowfall) {
                <ion-row class="sis-webreport-meteo-station-data">
                  <ion-col>
                    {{ 'webreport.term.latestSnowfall' | translate }}
                  </ion-col>
                  <ion-col>
                    {{ weatherStation.latestSnowfall }}
                  </ion-col>
                </ion-row>
              }
              @if (showAvalancheDangerLevel) {
                <ion-row class="sis-webreport-meteo-station-data">
                  <ion-col>
                    {{ 'webreport.term.avalancheDangerLevel' | translate }}
                  </ion-col>
                  <ion-col>
                    {{ getAvalancheDangerLevelTranslationString(weatherStation.avalancheDangerLevel) | translate }}
                  </ion-col>
                </ion-row>
              }
            </ion-grid>
          </div>
        </ion-col>
      }
    </ion-row>
  }
}
